namespace $.$$ {
	$mol_style_define( $shm_agent_app_sessions, {
		margin: { left: 0 },
		Drag: { padding: { left: 0 } },
	})
}
